import React from "react";
import { Link } from "react-router-dom";
class card extends React.Component {
  render() {
    return (
      <div className="card-avatar ">
        <div className="row">
          <div className="col s12 ">
            <div className="card hoverable">
              <div className="card-image"></div>
              <div className="card-content">
                <img src={this.props.img} alt="img name" />
                <Link to={`/profile/${this.props.login}`}>
                  {" "}
                  <span className="card-title bold poppins black-text">
                    {this.props.name}
                  </span>{" "}
                </Link>
                <p>{this.props.bio}</p>
              </div>

              <div className="card-actions">
                <div className="row">
                  <div className="col s6">
                    <div className="icon-footer">
                      <div className="icon">
                        <i className="material-icons">class</i>
                      </div>
                      <div className="iconwithtext">
                        <span className="d-block">Repos</span>
                        <span>{this.props.repos}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col s6">
                    <div className="icon-footer">
                      <div className="icon">
                        <i className="material-icons">favorite</i>
                      </div>
                      <div className="iconwithtext">
                        <span className="d-block">Followers</span>
                        <span>{this.props.followers}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default card;
